// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8ab44547","732":"447e1da6","977":"19a68214"}[chunkId] + ".chunk.js";
};